<template>
  <v-app>
    <PublicHeader/>
    <v-main>
      <v-container>
        <v-row class="mt-10 pt-10" justify="center">
          <v-col cols="2">
              <v-img class="mt-8" eager alt="Logo" contain src="@/assets/real-raven.png" transition="none"/>
          </v-col>
          <v-col class="mt-10 pt-10 text-center" cols="8">
            <div class="font-weight-light text-h5 text-sm-h4 text-md-h3 text-lg-h2 text-xl-h1">{{ $t('home.enterprise_blockchain')}}</div>
            <div class="mt-3 font-weight-light text-h5 text-sm-h4 text-md-h3 text-lg-h2 text-xl-h1">{{ $t('home.application_management')}}</div>        
            <div class="mt-10 text-center">
              <v-btn rounded :to="{ name: 'ravenpodCrystal'}" large color="primary">{{ $t('home.learn_more') }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>

  import Footer from '@/components/Footer.vue'
  import PublicHeader from '@/components/PublicHeader.vue'

  export default {
      components: {
        PublicHeader, Footer
      },
      data() {
          return {
          };
      },
      computed: {
      },
      created() {
      },
      methods: {
      }
  };

</script>
